/* eslint-disable no-undef */
import { baseClasses } from '@weatherbug/common';
import { Station, GetAllStationsParams, Location } from '../../components/locationManagerPopup/locationManagerPopupTypes';
const { PulseBaseProvider } = baseClasses;

const getAllStationsForLatLngKey = 'getAllStationsForLatLng';
const getAllStationsForLatLng = 'api/stations';
const updateLocationStationData = 'api/locations';
const queryLocationBySlugNameUri = 'api/locations/query';

export class ManageLocationsPopupProvider extends PulseBaseProvider {
    constructor(authId: string, secret: string, options: object, logger: object) {
        super(authId, secret, options, logger);
        window.storage.sync[getAllStationsForLatLngKey] = this.getAllStationsForLatLngSyncer.bind(this);
    }

    async getAllStationsForLatLngSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const { pulseApi, key } = syncParams;
        const queryParams = {
            lat: syncParams?.lat,
            lng: syncParams?.lng,
            radius: syncParams?.radius
        };
        return await super.syncData(key, id, queryParams, getAllStationsForLatLng, resolve, reject, validateGetAllStationsByLatLng, pulseApi, null, null, false);
    }

    async getAllStationsForLatLng({ lat, lng, radius = 15 }: GetAllStationsParams): Promise<Station[] | any> {
        const syncParams = {
            lat,
            lng,
            radius
        };
        const id = JSON.stringify(syncParams);

        return await super.loadFromStorage(getAllStationsForLatLngKey, id, syncParams);
    }

    async updateLocationStationData(location: Location) {
        const queryParams = {};

        return await super.putData(queryParams, location, `${updateLocationStationData}/${location?.Id}`, true, validateUpdateLocationStationData, false);
    }

    async queryLocationBySlugName(slugName: string): Promise<Location | any> {
        const queryParams = {};
        const reqPayload = {
            Query: slugName
        };

        return await super.postData(queryParams, reqPayload, queryLocationBySlugNameUri, true, validateUpdateLocationStationData, false);
    }
}

function validateGetAllStationsByLatLng(response: Station[]): boolean {
    return response || Array.isArray(response) && response.length > 0;
}

function validateUpdateLocationStationData(response: Location): Location {
    return response?.Id && response.Locality?.CityId;
}
